import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PAYMENTS_ACH_BASE_PATH } from '../../../../../../../../../features/payments/ach/payments-ach-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/ach/_ach')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'ach-payment-list',
        label: 'Payments',
        to: PAYMENTS_ACH_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
